import request from '@/utils/request'
// http://saassystem.hulianzaowu.cn/adminapi/staff/get_auth_userlist?name=&type=0&auth_type=1&limit=20&page=2
// 认证用户列表 - 个人
export function fetchPersonalUsers (query) {
  return request({
    url: 'staff/get_auth_userlist',
    method: 'get',
    params: {
      // 关键词搜索（姓名 / 手机号）
      name: query.keyword || '',
      // 0 个人，1 企业
      type: 0,
      // 认证类型：1 运营商认证 2 人脸认证；为空则查全部
      auth_type: query.auth_type || '',
      limit: query.limit,
      page: query.page
    }
  })
}

// 认证用户列表 - 企业
export function fetchEnterpriseUsers (query) {
  return request({
    url: 'staff/get_auth_userlist',
    method: 'get',
    params: {
      name: query.keyword || '',
      type: 1,
      // 0 全部，1 企业认证；不能用 ||，否则 0 会被当成假值变成 1
      auth_type: query.auth_type ?? 1,
      limit: query.limit,
      page: query.page
    }
  })
}

// 解绑个人认证
export function unbindPersonalUser (data) {
  return request({
    url: 'staff/del_auth_record',
    method: 'post',
    data: {
      id: data.id || data.user_id,
      type: 0 // 0 表示个人
    }
  })
}

// 解绑企业认证
export function unbindEnterpriseUser (data) {
  return request({
    url: 'staff/del_auth_record',
    method: 'post',
    data: {
      id: data.id || data.company_id,
      type: 1 // 1 表示企业
    }
  })
}

// 待认证企业列表
export function fetchPendingEnterpriseList (query) {
  return request({
    url: 'staff/get_pending_enterprise_list',
    method: 'get',
    params: {
      // 关键词搜索（企业名称 / 统一社会信用代码 / 法人姓名）
      keyword: query.keyword || '',
      // 认证类型：1 运营商三要素 2 人脸认证；为空则查全部
      auth_type: query.auth_type || '',
      limit: query.limit,
      page: query.page
    }
  })
}

// 查看营业执照
export function viewBusinessLicense (data) {
  return request({
    url: 'staff/get_business_license',
    method: 'get',
    params: {
      id: data.id
    }
  })
}

// 查看授权书
export function viewAuthBook (data) {
  return request({
    url: 'staff/get_auth_book',
    method: 'get',
    params: {
      id: data.id
    }
  })
}

// 审核企业认证
export function reviewEnterprise (data) {
  return request({
    url: 'staff/review_enterprise',
    method: 'post',
    data: {
      id: data.id,
      status: data.status // 1 审核通过，2 审核失败
    }
  })
}